import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

/**
 * SWOOP-267 — Temporary tenant-admin-only test screen for the "Generate a Document and
 * Collect a Customer Response" epic (SWOOP-265). It exists to prove the document
 * generation/response path before any business entity depends on it, and MUST be removed
 * once the epic lands — do not build product features on top of this route.
 *
 * Gating: `document-templates:list`, the epic's own resource (the DOCX templates uploaded here),
 * granted to TENANT_ADMIN only in `built-in.ts`. NOT the existing `documents:*` family — that
 * covers vehicle/tenant document metadata and FLEET_MANAGER holds it, which would have let Fleet
 * Managers in and broken the "only a tenant admin" AC.
 *
 * This is a frontend-only gate today: SWOOP-267 ships no API. The matching
 * `@HetivoAuthenticator('document-templates:list' | ':manage')` guards land with the upload and
 * generation endpoints in SWOOP-268 onwards — a route gate alone is not a security boundary.
 */
export const Route = createFileRoute('/_authenticated/document-test')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('document-templates:list')) {
      throw redirect({ to: '/' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/document-template/pages/document-test-page')),
  staticData: { titleKey: 'documentTest' },
});
